import Controller from '@ember/controller';
import { action, computed, get } from '@ember/object';
import { alias } from '@ember/object/computed';
import { service } from '@ember/service';
import { isPresent } from '@ember/utils';
import { serializeAppliedFilters } from 'donor-elf-web/lib/filter-utils-new';

export default Controller.extend({
  router: service(),

  goal: alias('model.dashboard.goal'),
  fund: alias('model.fund'),

  monthlyGoalAmount: computed('goal.goalAmount', function () {
    let annualGoalAmount = get(this, 'goal.goalAmount');
    if (isPresent(annualGoalAmount)) {
      return Math.round(annualGoalAmount / 12);
    } else {
      return null;
    }
  }),

  ytdAmount: alias('goal.goalData.ytd_amount'),
  ytdPercent: computed('ytdAmount', 'goal.goalAmount', function () {
    let goalAmount = get(this, 'goal.goalAmount') || 0;
    let ytdAmount = this.ytdAmount || 0;
    if (goalAmount === 0) {
      return 0;
    }
    return Math.round((ytdAmount * 100) / goalAmount);
  }),

  chartClicked: action(function () {
    this.router.transitionTo('funds.fund.transactions', {
      queryParams: {
        filters: serializeAppliedFilters([
          {
            propertyName: 'transDate',
            operation: '>=',
            val: this.goal?.goalData?.start_date,
          },
        ]),
      },
    });
  }),
});
